import { generateKeys } from '../utils';
export const locales = generateKeys({
    ar: { value: 'ar', label: 'ar' },
    cs: { value: 'cs', label: 'cs' },
    da: { value: 'da', label: 'da' },
    de: { value: 'de', label: 'de' },
    el: { value: 'el', label: 'el' },
    en: { value: 'en', label: 'en' },
    es: { value: 'es', label: 'es' },
    fi: { value: 'fi', label: 'fi' },
    fr: { value: 'fr', label: 'fr' },
    hi: { value: 'hi', label: 'hi' },
    hu: { value: 'hu', label: 'hu' },
    id: { value: 'id', label: 'id' },
    it: { value: 'it', label: 'it' },
    ko: { value: 'ko', label: 'ko' },
    mn: { value: 'mn', label: 'mn' },
    ms: { value: 'ms', label: 'ms' },
    nl: { value: 'nl', label: 'nl' },
    no: { value: 'no', label: 'no' },
    ph: { value: 'ph', label: 'ph' },
    pl: { value: 'pl', label: 'pl' },
    pt: { value: 'pt', label: 'pt' },
    ro: { value: 'ro', label: 'ro' },
    ru: { value: 'ru', label: 'ru' },
    sv: { value: 'sv', label: 'sv' },
    th: { value: 'th', label: 'th' },
    tr: { value: 'tr', label: 'tr' },
    vi: { value: 'vi', label: 'vi' },
    zh: { value: 'zh', label: 'zh' },
});
